var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStravaLogoIcon147232(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F04F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1701 20.0804L25.519 26.6904H30.4415L22.1701 10.3627L13.9 26.6904H18.8236L22.1701 20.0804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9495 31.7029L25.457 26.785H21.7935L27.9495 38.9339L34.1012 26.785H30.4404L27.9495 31.7029Z",
    fill: "#FFA780"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStravaLogoIcon147232);
export default __webpack_public_path__ + "static/media/strava_logo_icon_147232.01bbb3bc6e08f8211ffe47497f703d4d.svg";
export { ForwardRef as ReactComponent };